import React, {Component} from "react";
import {FormattedMessage} from "react-intl";


class ArticlesHeader extends Component {

    render() {

        return (
            <thead>
            <tr>
                <th>
                    <FormattedMessage id="app.article-header.no"
                                      defaultMessage="#"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.article-header.date"
                                      defaultMessage="Date"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.article-header.title"
                                      defaultMessage="Title"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.article-header.author"
                                      defaultMessage="Author"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.article-header.actions"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>
            </tr>
            </thead>
        )

    }
}

export default ArticlesHeader;


// WEBPACK FOOTER //
// ./src/components/Admin/Articles/ViewAllArticles/ArticlesHeader/ArticlesHeader.js